<template>
  <section id="all-hospitals-view" class="all-cases-view">
    <div class="container-small-table">
      <div class="listings-navbar">
        <ul class="d-flex flex-wrap justify-content-end list-items-group-15">
          <li>
            <div class="form-element input-with-icon search-input-lg">
              <el-input
                v-model="search_string"
                @input="getAutoCompleteLabsData"
                placeholder="Search"
                clearable
              ></el-input>
              <span>
                <img
                  src="@/assets/images/icons/search-icon-with-bg-red.svg"
                  alt="icon"
                  class="img-fluid icon"
                />
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="getLabs.data"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'desc' ? 'descending' : 'ascending',
            }"
            ref="multipleTable"
            @sort-change="onChangeSort"
          >
            <el-table-column
              label="Lab Name"
              prop="name"
              min-width="250"
              sortable="custom"
            >
              <template #default="scope">{{ scope.row.name || "-" }}</template>
            </el-table-column>
            <el-table-column label="Lab Code" prop="lab_code" width="150">
              <template #default="scope">{{
                scope.row.lab_code || "-"
              }}</template>
            </el-table-column>
            <el-table-column prop="email" label="Email" width="350">
              <template #default="scope">
                <span class="table_cell-ellipsis">{{ scope.row.email }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="Phone No" width="180">
              <template #default="scope">
                <span class="text-center">{{ scope.row.phone }}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="action"
              label="Action"
              fixed="right"
              width="170"
            >
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li>
                    <el-button
                      @click="onView(scope.row._id)"
                      class="view-button"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li>
                    <el-button
                      @click="editLab(scope.row._id)"
                      class="edit-button"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/profile/edit-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/profile/edit-icon.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li>
                    <el-button
                      @click="viewPanels(scope.row._id)"
                      class="view-button"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/panels-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/panels-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li>
                    <el-button
                      @click="viewUsers(scope.row._id)"
                      class="view-button"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/users-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/users-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li>
                    <el-button
                      @click="viewWorkSheets(scope.row._id)"
                      class="view-button"
                    >
                      <img
                        src="@/assets/images/icons/actions/panels-active.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="listings listings__pagination">
        <el-pagination
          v-model:currentPage="page"
          v-model:page-size="pageSize"
          :page-sizes="[10, 25, 50, 100]"
          :small="small"
          :disabled="disabled"
          :background="background"
          layout=" prev, pager, next, jumper, sizes ,total"
          :total="getLabs.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import exportExcelHelper from "@/mixins/exportExcelHelper";
import FilterHelper from "@/mixins/FilterHelper";
import { labSearchOptions } from "@/config/constants/searchConstants";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  mixins: [exportExcelHelper, FilterHelper],
  data() {
    return {
      search_string: "",
      previousSearchString: "",
      page: 1,
      total: 0,
      loading: false,
      hospitalsTable: {},
      exportDialogVisisble: false,
      fieldList: [],
      activeFieldList: [],
      pageSize: 25,
      orderBy: "updated_at",
      orderType: "DESC",
      pageSizes: [10, 25, 30, 50],
      checkAll: true,
      searchByKey: ["labName", "labCode", "Email", "PhoneNo"],
      searchBy: "",
      searchOptions: labSearchOptions,
    };
  },
  computed: {
    ...mapGetters("labs", ["getLabs"]),
    paginationProps() {
      return {
        pageSizes: this.pageSizes || [10, 25, 30, 50],
      };
    },
    isSearchByInput() {
      return this.searchByKey.indexOf(this.searchBy) != -1 ? true : false;
    },
  },
  async mounted() {
    this.setQueryParamsData();
    await this.fetchLabsList();
  },
  methods: {
    async fetchLabsList() {
      this.loading = true;
      let params = {
        page: this.page,
        limit: this.pageSize,
        order_by: this.orderBy || "updated_at",
        order_type: this.orderType || "desc",
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      await this.$store.dispatch("labs/fetchAllLabs1", params);
      this.updateQueryParams(params);

      this.loading = false;
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedLabPage: params.page,
        selectedLabPageSize: params.limit,
        selectedLabString: params.search_string,
        selectedLabSearchBy: this.searchBy || undefined,
        selectedOrderBy: params.order_by,
        selectedOrderType: params.order_type,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedLabPage
        ? parseInt(this.$route.query.selectedLabPage)
        : 1;
      this.pageSize = this.$route.query.selectedLabPageSize
        ? parseInt(this.$route.query.selectedLabPageSize)
        : 25;
      if (this.$route.query.selectedLabString) {
        this.search_string = this.$route.query.selectedLabString;
      }
      this.searchBy = this.$route.query.selectedLabSearchBy;
      this.orderBy = this.$route.query.selectedOrderBy;
      this.orderType = this.$route.query.selectedOrderType;
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "updated_at";
        this.orderType = "desc";
      }
      this.fetchLabsList();
    },
    clearInputSearch() {
      this.search_string = "";

      this.isSearchByInput = "";
      this.page = 1;
      this.fetchLabsList(1);
    },
    onView(id) {
      this.$router.push({
        path: "/view-lab",
        name: "ViewLab",
        params: {
          lab_id: id,
        },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    editLab(id) {
      this.$router.push({
        path: "/edit-lab",
        name: "EditLab",
        params: {
          lab_id: id,
        },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },

    viewPanels(id) {
      this.$router.push({
        path: "/test-panel",
        name: "TestPanel",
        params: {
          lab_id: id,
        },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    viewUsers(id) {
      this.$router.push({
        name: "LabUsers",
        params: {
          lab_id: id,
        },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    viewWorkSheets(id) {
      this.$router.push({
        name: "WorkSheets",
        params: {
          lab_id: id,
        },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchLabsList();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchLabsList();
    },
    async getAutoCompleteLabsData() {
      setTimeout(() => {
        this.page = 1;
        this.fetchLabsList();
      }, 600);
    },
    clearLabsSearch() {
      this.search_string = "";
      this.previousSearchString = "";
      this.fetchLabsList(1);
    },
  },
};
</script>

<style lang="scss" scoped></style>
